<div class="phone-picker">
    <ng-select [items]="countryCodes | async" [formControl]="formControl"
        [formlyAttributes]="field" bindLabel="display_name" bindValue="dial_code">
        <ng-template ng-label-tmp let-item="item">
            <span class="flag flag-{{item.icon}}"></span>
            <span>{{item.dial_code}}</span>
        </ng-template>
    </ng-select>
</div>